<div class="mib-dialog flex flex-col gap-6" role="dialog">
  <h3 class="text-lg">{{ data.title }}</h3>
  <div class="text-gray-600">{{ data.description }}</div>
  <footer class="flex gap-3 justify-end">
    <mib-button theme="secondary" (click)="dialogRef.close(false)">Cancel</mib-button>
    <mib-button [theme]="data.type || 'primary'" (click)="dialogRef.close(true)">{{ data.confirmLabel }}</mib-button>
  </footer>
</div>
